module.exports = __webpack_public_path__ + "img/rj-int-logo.265415e6.png";